import { Component, Input } from '@angular/core';
import { LatestDocumentViewModel } from '../../../models/documentation/latest-legal-document-view-model';

@Component({
	selector: 'eif-navigation-documents',
	template: `
		<div class="navigation-documents">
			@for (latestDocument of latestDocuments; track latestDocument; let i = $index) {
				<a
					id="{{ 'latestAcceptedDocument_' + i + '_link' }}"
					(click)="openLegalDocument(latestDocument)">
					{{ latestDocument.LegalDocumentTypeTranslation }}
				</a>
			}
		</div>
	`,
	styles: [
		`
			.navigation-documents {
				display: flex;
				flex-direction: row-reverse;
				flex-wrap: wrap;
				gap: 1rem;
				padding: 0.6em 0.9em 0.6rem;
				background-color: rgba(0, 0, 0, 0.02);
				margin-top: 0.5rem;

				a {
					cursor: pointer;
					font-size: 0.75rem;
				}
			}
		`,
	],
	standalone: false,
})
export class NavigationDocumentsComponent {
	@Input() latestDocuments: LatestDocumentViewModel[];
	@Input() openLegalDocument: (latestDocument: LatestDocumentViewModel) => void;
}
